// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 210 ? "vendor.footer-component" : chunkId) + "." + {"75":"59f3e390","155":"719fd78e","210":"c2a63c38","453":"b6ca7014","502":"a86453a3","518":"a8d86760","567":"72e82ac4","704":"5f40e0af","721":"cab62217","771":"0436fa43"}[chunkId] + ".chunk.js";
};